module.exports = __webpack_public_path__ + "dingbeauty-landing/img/industry_04@1.692c6b90.png";